import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  Box,
} from "@mui/material";
import useUpdate from "../../api/useUpdate";
import { useTranslation } from "react-i18next";

const Edit = ({ open, onClose, editData, token }) => {
  const { t } = useTranslation();
  const { handleUpdate, loading, isSuccess } = useUpdate(
    "shop/categories",
    token
  );

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [selectedShop, setSelectedShop] = useState("");

  useEffect(() => {
    setName(editData?.name);
    setDescription(editData?.description);
    setSelectedShop(editData?.shop);
  }, [editData]);

  const handleSubmit = () => {
    const formData = {
      name: name.trim(),
      description,
      shop: selectedShop,
    };
    handleUpdate(editData?.id, formData);
  };

  useEffect(() => {
    if (isSuccess) {
      setName("");
      setDescription("");
      setSelectedShop("");
      onClose();
    }
  }, [isSuccess, onClose]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t("category.editCategory")}</DialogTitle>
      <DialogContent>
        <Box component="form" noValidate sx={{ mt: 1 }}>
          <TextField
            autoFocus
            margin="dense"
            label={t("category.categoryName")}
            type="text"
            fullWidth
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            margin="dense"
            label={t("category.description")}
            type="text"
            fullWidth
            multiline
            rows={4}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={loading}>
          {t("category.cancel")}
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={loading || !name.trim()}
          sx={{ minWidth: 100 }}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            t("category.submit")
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Edit;
